var map = {
	"./bad.json": 63,
	"./goal.json": 64,
	"./good.json": 65,
	"./greenball.json": 27,
	"./hamburger.json": 66,
	"./like.json": 67,
	"./loader.json": 17,
	"./no-results.json": 47,
	"./ok.json": 68,
	"./snake.json": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62;